// Константы для Form2

// Функция для получения пустых данных формы
export const getEmptyFormData = () => {
  return {
    // Информация
    cnl: '',             // Целевое назначение лесов
    kzl: '',             // Кат ЗЛ
    proishozdenie: '',   // Происхождение насаждения
    ozu: '',             // ОЗУ
    arenda: '',          // Право пользования
    vidarenda: '',       // Вид использования
    oopt: '',            // ООПТ
    noopt: '',           // Иное ООПТ
    glu: '',             // Год лесоустройства
    itaks2: '',          // Информация пользователя
    landAvailability: null, // Доступность участка (null — не выбрано; true/false — да/нет)
    // Характеристика насаждения общая
    katzem: '',          // Категория земель
    gporoda: '',         // Главная порода
    bonitet: '',         // Бонитет
    tiplesa: '',         // Тип леса
    tlu: '',             // ТЛУ
    // Характеристика насаждения по ярусам
    yarusy: [{           // Массив ярусов
      id: 1,
      yarus: '1',        // Ярус (1, 2, 3)
      sostav: '',        // Состав насаждения
      visota: '',        // Высота яруса
      klvozr: '',        // Класс возраста
      grvozr: '',        // Группа возраста
      polnota: '',       // Полнота
      zapassirga: '',    // Запас сырораст., кбм на га
      zapassir: '',      // Запас сырораст., кбм на выдел
      zapassuh: '',      // Запас сухостоя, кбм на выдел
      zapasred: '',      // Запас редин, кбм на выдел
      zapased: '',       // Запас един. дер., кбм на выдел
      zapaszahl: '',     // Запас захл. общ., кбм на выдел
      zapaszahllik: ''   // Запас захл. ликвид., кбм на выдел
    }],
    // Характеристика породы
    poroda_characteristics: [{ // Массив характеристик пород
      id: 1,
      yarus: '',         // Ярус (нередактируемое)
      dolap: '',         // Доля (нередактируемое)
      kodporodato: '',   // Порода (нередактируемое)
      vozr: '',          // Ср. возраст, лет
      hsr: '',           // Ср. высота, м
      dsr: ''            // Ср. диаметр, см
    }],
    dependentData: {
      organizations: [],
      forestDistricts: [],
      subDistricts: [],
      toponyms: []
    }
  };
};

